import { VariableType } from 'json-to-graphql-query';

import { Button } from '@/interfaces/button';
import { EntityResource } from './entity.resource';

/**
 * Resource przycisków
 *
 * @export
 * @class ButtonResource
 * @extends {EntityResource<Button>}
 */
export class ButtonResource extends EntityResource<Button> {
  public listVariables = { filters: 'ButtonFilters' };

  public getFields = {
    id: true,
    name: true,
    routeName: true,
    action: true,
    order: true
  };

  public listFields = {
    id: true,
    name: true,
    routeName: true,
    action: true,
    actionData: true,
    icon: true,
    color: true,
    statusId: true,
    roleIds: true,
    schemaId: true,
    creatorOnly: true,
    singleOnly: true,
    order: true
  };

  constructor() {
    super({
      entityName: 'button'
    });
  }

  /**
   * Użycie przycisku
   *
   * @param {object} variables
   * @returns {Promise<number>}
   * @memberof ButtonResource
   */
  public use(variables: object): Promise<number> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { id: 'Int!', entityId: 'String!', entityType: 'StageType!', data: 'JSON' },
        buttonUse: {
          __args: {
            id: new VariableType('id'),
            entityId: new VariableType('entityId'),
            entityType: new VariableType('entityType'),
            data: new VariableType('data')
          }
        }
      }
    });
    return this.mutation({ mutation, variables }, 'buttonUse');
  }

  /**
   * Użycie przycisku do wielu encji jednocześnie
   *
   * @param {object} variables
   * @returns {Promise<number>}
   * @memberof ButtonResource
   */
  public useMultiple(variables: object): Promise<number> {
    const mutation = this.prepareOptions({
      mutation: {
        __variables: { id: 'Int!', entityIds: '[String!]!', entityType: 'StageType!', data: 'JSON' },
        buttonUseMultiple: {
          __args: {
            id: new VariableType('id'),
            entityIds: new VariableType('entityIds'),
            entityType: new VariableType('entityType'),
            data: new VariableType('data')
          }
        }
      }
    });
    return this.mutation({ mutation, variables }, 'buttonUseMultiple');
  }
}

export const buttonResource = new ButtonResource();
